var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
import { FilterService } from '~/utils/filter.service';
import { Service } from '~/core/service';
var OutsourceReconciliationManageService = /** @class */ (function (_super) {
    __extends(OutsourceReconciliationManageService, _super);
    function OutsourceReconciliationManageService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 委外对账列表
     */
    OutsourceReconciliationManageService.prototype.caseOutContrastList = function (data, page) {
        return this.netService.send({
            server: domainService.outsourceReconciliationManageController.caseOutContrastList,
            data: {
                outBatch: data.outBatch,
                caseNumber: data.caseNumber,
                checkStatus: data.checkStatus,
                entryTimeStart: FilterService.dateRanageFormat(data.entryTime).start,
                entryTimeEnd: FilterService.dateRanageFormat(data.entryTime).end,
                outId: data.outId,
            },
            page: page,
        });
    };
    /**
     * 调账
     */
    OutsourceReconciliationManageService.prototype.accountAdjustment = function (data) {
        return this.netService.send({
            server: domainService.outsourceApplyRecordReconciliationController.accountAdjustment,
            data: data
        });
    };
    /**
     * 案件统计
     */
    OutsourceReconciliationManageService.prototype.caseStatistics = function (data) {
        return this.netService.send({
            server: domainService.outsourceReconciliationManageController.caseStatistics,
            data: data
        });
    };
    /**
     * 对账单核对
     */
    OutsourceReconciliationManageService.prototype.checkBill = function (fileId) {
        return this.netService.send({
            server: domainService.outsourceReconciliationManageController.checkBill,
            data: { fileId: fileId },
            loading: true
        });
    };
    /**
     * 根据委外方查询批次号下拉列表
     */
    OutsourceReconciliationManageService.prototype.selectBatchNumberList = function (data) {
        return this.netService.send({
            server: domainService.outsourceReconciliationManageController.selectBatchNumberList,
            data: data
        });
    };
    /**
     * 根据委外方查询批次号下拉列表
     */
    OutsourceReconciliationManageService.prototype.generatingBill = function (data) {
        return this.netService.send({
            server: domainService.outsourceReconciliationManageController.generatingBill,
            data: data
        });
    };
    /**
     * 委外管理-委外对账-对账单导出
     */
    OutsourceReconciliationManageService.prototype.exportBills = function (data, loading) {
        return this.netService.send({
            server: domainService.outsourceReconciliationManageController.exportBills,
            data: data,
            loading: loading
        });
    };
    /*
     * 委外管理-委外对账-导入还款记录
     */
    OutsourceReconciliationManageService.prototype.importRepaymentRecord = function (data) {
        return this.netService.send({
            server: domainService.outsourceReconciliationManageController.importRepaymentRecord,
            data: data
        });
    };
    __decorate([
        Inject(NetService)
    ], OutsourceReconciliationManageService.prototype, "netService", void 0);
    return OutsourceReconciliationManageService;
}(Service));
export { OutsourceReconciliationManageService };
